export const createImg = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();

    let onLoad, onError;

    const cleanup = () => {
      img.removeEventListener('load', onLoad);
      img.removeEventListener('error', onError);
    };

    onLoad = () => {
      resolve(img);
      cleanup();
    };

    onError = (error) => {
      reject(error);
      cleanup();
    };

    img.addEventListener('load', onLoad);
    img.addEventListener('error', onError);
    img.src = url;
  });
